import { ActivityStatus } from '@common/interfaces/activity'
import { OngoingReportingStatus } from '@common/interfaces/bbc'
import { BoxSignStatusLabel } from '@common/interfaces/box'
import { AmendmentAnalysisStatus } from '@common/interfaces/generalAnalysis'
import { TaskStatus } from '@common/interfaces/task'
import genericSs from '../../assets/styles/generic.module.scss'

const NOT_STARTED_STATUSES: ReadonlySet<string> = new Set<string>([
  TaskStatus.NotStarted,
  TaskStatus.Archived,
  OngoingReportingStatus.Uploaded,
])

const IN_PROGRESS_STATUSES: ReadonlySet<string> = new Set<string>([
  TaskStatus.InProgress,
  ActivityStatus.Review,
  TaskStatus.InReview,
])

const FAILURE_STATUSES: ReadonlySet<string> = new Set<string>([
  BoxSignStatusLabel.Cancelled,
  BoxSignStatusLabel.Declined,
  BoxSignStatusLabel.Expired,
  BoxSignStatusLabel.Error,
])

const COMPLETE_STATUSES: ReadonlySet<string> = new Set<string>([TaskStatus.Complete])

// The amendment ladder's later steps each get their own colour so a board mixing
// analyses at different stages reads at a glance (In Review shares the
// in-progress yellow, Archived the not-started grey).
const AMENDMENT_STATUS_CLASSES: ReadonlyMap<string, string> = new Map<string, string>([
  [AmendmentAnalysisStatus.Approved, genericSs.blue],
  [AmendmentAnalysisStatus.LegalDocs, genericSs.indigo],
])

/** Maps task status label to `generic.module.scss` reporting-status color class. */
export function getTaskStatusClass(status: string | null): string {
  const s = status || TaskStatus.NotStarted
  if (COMPLETE_STATUSES.has(s)) {
    return genericSs.complete
  }
  if (NOT_STARTED_STATUSES.has(s)) {
    return genericSs.notStarted
  }
  if (IN_PROGRESS_STATUSES.has(s)) {
    return genericSs.inProgress
  }
  if (FAILURE_STATUSES.has(s)) {
    return genericSs.overdue
  }
  return AMENDMENT_STATUS_CLASSES.get(s) ?? genericSs.blue
}
